/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Candidate_Profile_Title_Application_OverviewInputs */

const en_candidate_profile_title_application_overview = /** @type {(inputs: Candidate_Profile_Title_Application_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Application overview`)
};

const de_candidate_profile_title_application_overview = /** @type {(inputs: Candidate_Profile_Title_Application_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewerbungsübersicht`)
};

/**
* | output |
* | --- |
* | "Application overview" |
*
* @param {Candidate_Profile_Title_Application_OverviewInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const candidate_profile_title_application_overview = /** @type {((inputs?: Candidate_Profile_Title_Application_OverviewInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Candidate_Profile_Title_Application_OverviewInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_candidate_profile_title_application_overview(inputs)
	return en_candidate_profile_title_application_overview(inputs)
});